import template from './dashboard-new-joiner-checklist.component.html';
import controller from './dashboard-new-joiner-checklist.controller';

const dashboardNewJoinerChecklist = {
  template,
  controller,
};

export default dashboardNewJoinerChecklist;
